/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserGlobalSettingsPartial } from '../../models/user-global-settings-partial';
import { UserGlobalSettingsWithRelations } from '../../models/user-global-settings-with-relations';

export interface UpdateById$Params {
      body?: UserGlobalSettingsPartial
}

export function updateById(http: HttpClient, rootUrl: string, params?: UpdateById$Params, context?: HttpContext): Observable<StrictHttpResponse<UserGlobalSettingsWithRelations>> {
  const rb = new RequestBuilder(rootUrl, updateById.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserGlobalSettingsWithRelations>;
    })
  );
}

updateById.PATH = '/user/global-settings';
